(ns scittle.re-frame-undo
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [day8.re-frame.undo]))

;; Plugin: re-frame-undo
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::re-frame-undo
   {:namespaces
   {'day8.re-frame.undo (sci/copy-ns day8.re-frame.undo (sci/create-ns 'day8.re-frame.undo nil))}}
   ))
